import { useIntl, FormattedMessage } from "react-intl";
import BigSteps from "../../../../common/core-ui/BigSteps.tsx";
import styles from "./SearchSampleScreen.module.scss";

export default function StartSampleScreen() {
  const intl = useIntl();

  return (
    <>
      <BigSteps
        title={
          <FormattedMessage defaultMessage="We’ve Added Almost 1 Million Free eBook Samples!" />
        }
        steps={[
          {
            title: intl.formatMessage({
              defaultMessage: "Thinking About a New Adoption?",
            }),
            detail: (
              <FormattedMessage defaultMessage="Search by ISBN, title, subject or publisher to find course related titles." />
            ),
          },
          {
            title: intl.formatMessage({
              defaultMessage: "Compare Similar Titles.",
            }),
            detail: (
              <FormattedMessage defaultMessage="Evaluate the book's fit for your course with book description, digital enhancements and available courseware." />
            ),
          },
          {
            title: intl.formatMessage({
              defaultMessage: "Add to My Library for Full Access.",
            }),
            detail: (
              <FormattedMessage defaultMessage="Verified instructors get 1 year of complimentary access to the entire eBook!" />
            ),
          },
        ]}
      />
      <div className={styles.bottomAnchors}>
        <FormattedMessage defaultMessage="Explore free samples. We're continually adding titles and refining results." />
      </div>
    </>
  );
}
